import React, {Component} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom';
import * as THREE from 'three';
import STLLoaderModule from 'three-stl-loader'
import OrbitControlsModule from 'three-orbit-controls'
import {ScaleLoader} from 'react-spinners';
import SelectInput from '@material-ui/core/Select/SelectInput';

const STLLoader = STLLoaderModule(THREE);
const OrbitControls = OrbitControlsModule(THREE);

class STLViewer_ extends Component {
    static propTypes = {
        className: PropTypes.string,
        objects: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        backgroundColor: PropTypes.string,
        modelColor: PropTypes.string,
        sceneClassName: PropTypes.string,
        onSceneRendered: PropTypes.func,
    };

    static defaultProps = {
        backgroundColor: '#EAEAEA',
        modelColor: '#B92C2C',
        objects: [],
        height: 400,
        width: 400,
        rotate: true,
        orbitControls: true,
        sceneClassName: '',
    };

    componentDidMount() {
        this.renderModel(this.props);
    }

    renderModel(props) {
        let camera, scene, renderer, mesh, distance, controls;
        const {objects, backgroundColor, orbitControls, sceneClassName, onSceneRendered} = props;
        let component = this;

        const canvas = ReactDOM.findDOMNode(this).firstChild;
        // look up the size the canvas is being displayed
        const width = canvas.clientWidth;
        const height = canvas.clientHeight;

        scene = new THREE.Scene();
        distance = 10000;
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.6);
        directionalLight.position.x = 0.1;
        directionalLight.position.y = 0.51;
        directionalLight.position.z = 0.1;
        directionalLight.position.normalize();
        scene.add(directionalLight);

        const ambientLight = new THREE.AmbientLight(0xC6C6C6); // soft white light
        scene.add(ambientLight);


        const loader = new STLLoader();

        //alert(objects.length);
        let xDims_Total = [0.0, 0.0];
        let yDims_Total = [0.0, 0.0];
        let zDims_Total = [0.0, 0.0];
        let progresses = Array(objects.length).fill(0.0);


        for (var i = 0; i < objects.length; i++) {

            const index_Object = i;

            loader.load(objects[index_Object].path, 
                        geometry => {
                            
                            geometry.computeFaceNormals();
                            geometry.computeVertexNormals();
                            //geometry.center();
                
                            mesh = new THREE.Mesh(
                                geometry,
                                new THREE.MeshLambertMaterial({
                                        overdraw: true,
                                        color: objects[index_Object].color,
                                    }
                                ));
                
                            
                            mesh.rotateX(-1.5708);
                            mesh.rotateZ(0.785398);
                            scene.add(mesh);



                            geometry.computeBoundingBox();
                            xDims_Total = [Math.min(geometry.boundingBox.min.x, xDims_Total[0]), Math.max(geometry.boundingBox.max.x, xDims_Total[1])];
                            yDims_Total = [Math.min(geometry.boundingBox.min.y, yDims_Total[0]), Math.max(geometry.boundingBox.max.y, yDims_Total[1])];
                            zDims_Total = [Math.min(geometry.boundingBox.min.z, zDims_Total[0]), Math.max(geometry.boundingBox.max.z, zDims_Total[1])];


                            
                            if (index_Object == objects.length - 1 || true) {

                    
                                const activateCamera = () => {

                                    camera = new THREE.PerspectiveCamera(30, width / height, 1, distance);
                                    camera.position.set(0, 0, Math.max((xDims_Total[1] - xDims_Total[0]) * 3, (yDims_Total[1] - yDims_Total[0]) * 3, (zDims_Total[1] - zDims_Total[0]) * 3));
                                    camera.lookAt(scene.position);

                                    scene.add(camera);


                                    this.props.onSTLBounds([xDims_Total[0], xDims_Total[1], yDims_Total[0], yDims_Total[1], zDims_Total[0], zDims_Total[1]]); 
                        
    
                                    renderer = new THREE.WebGLRenderer({
                                        preserveDrawingBuffer: true,
                                        antialias: true
                                    });
                                    renderer.setSize(width, height);
                                    renderer.setClearColor(backgroundColor, 1);
                                    renderer.domElement.className = sceneClassName;
                        
                                    if (orbitControls) {
                                        controls = new OrbitControls(camera, ReactDOM.findDOMNode(component));
                                        controls.enableKeys = false;
                                        controls.addEventListener('change', orbitRender);
                                    }
                        
                                    ReactDOM.findDOMNode(this).replaceChild(renderer.domElement, ReactDOM.findDOMNode(this).firstChild);
                        
    
                                    render();
                        
    
                                    if (typeof onSceneRendered === "function")
                                        onSceneRendered(ReactDOM.findDOMNode(renderer.domElement));

                                };


                                const waiter = () => {

                                    var flag = true;

                                    for (var j = 0; j < progresses.length; j++) {
                                        
                                        if (progresses[j] < 0.99) {
                                            flag = false;
                                            break;
                                        }

                                    }

                                    
                                    if (flag == true) {

                                        activateCamera();

                                    } else {

                                        setTimeout(function(){ 

                                            waiter();
        
                                        }, 100);

                                    }

                                };


                                waiter();

                                
                            }


                        }, 
                        (xhr) => { 
                            if (xhr.lengthComputable) {
                                progresses[index_Object] = xhr.loaded / xhr.total;
                            }
                        },
                        (error) => {
                            alert(JSON.stringify(error, ["message", "arguments", "type", "name"]));
                        } );

        }


        const render = () => {
            renderer.render(scene, camera);
        };


        const orbitRender = () => {
            render();
        };

    }

    shouldComponentUpdate(nextProps, nextState) {
        if (JSON.stringify(nextProps) === JSON.stringify(this.props)) {
            return false;
        }

        this.props = nextProps;
        this.renderModel(nextProps);
        
        return true;
    }

    componentDidUpdate(nextProps, nextState) {
        //alert(JSON.stringify(nextProps));
        //this.renderModel(nextProps);
    }

    componentDidCatch(error, info) {
        console.log(error, info)
    }

    render() {
        return (
            <div
                className={this.props.className}
                style={{
                    width: '100%',
                    height: '100%',
                    overflow: 'hidden',
                }}
            >
                <div style={{
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <ScaleLoader
                        color={'#123abc'}
                        loading={true}
                    />
                </div>
            </div>
        );
    };
    
};


const mapStateToProps = (state, props) => {

    return {
    };
  
  }
  
  const mapDispatchToProps = (dispatch, props) => {
  
    return {
      onSTLBounds:(val) => { dispatch({ type: "STL:BOUNDS", value: val }) }
    };
    
  }


const STLViewer = connect(mapStateToProps, mapDispatchToProps)(STLViewer_)
export default STLViewer;
